import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'
const equipRouter = {
  path: '/tissuemanage',
  redirect: 'noredirect',
  name: 'tissuemanage',
  component: Layout,
  children: [
    {
      path: 'tissuemanage',
      component: () => import('@/views/tissuemanage/index.vue'),
      name: 'tissuemanage',
      meta: {
        title: '课题申报管理',
        icon: 'tissue',
        requireAuth: true,
      }
    },
  ]
}

export default equipRouter
